import { render, staticRenderFns } from "./order-status-component.vue?vue&type=template&id=b3d775c8&scoped=true"
import script from "./order-status-component.vue?vue&type=script&lang=js"
export * from "./order-status-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d775c8",
  null
  
)

export default component.exports